import styled from 'styled-components'

import { LoginButton } from '../KindeLogin/KindeLogin.styled'

export const ContentContainer = styled.div`
  padding: 0 48px;
  text-align: center;
`

export const MessageContainer = styled.div`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 10px;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 5px;
  border: ${(props) =>
    props.$isWarning && props.$isDrayNow
      ? '1px solid #78BE20'
      : props.$isWarning && !props.$isDrayNow
        ? '1px solid #44BBA4'
        : props.$isDrayNow
          ? '1px solid #B15C60'
          : '1px solid #E63734'};
  background: ${(props) =>
    props.$isWarning && props.$isDrayNow
      ? 'rgba(120, 190, 32, 0.10)'
      : props.$isWarning && !props.$isDrayNow
        ? 'rgba(68, 187, 164, 0.10)'
        : props.$isDrayNow
          ? 'rgba(177, 92, 96, 0.05)'
          : 'rgba(230, 55, 52, 0.05)'};
`

export const ErrorMessagePrimary = styled.p`
  text-align: left;
  color: ${(props) =>
    props.$isWarning && props.$isDrayNow
      ? '#262626'
      : props.$isWarning && !props.$isDrayNow
        ? '#2B4141'
        : props.$isDrayNow
          ? '#b15c60'
          : '#E63734'};
  font-family: 'Inter';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const ErrorMessageSecondary = styled.p`
  text-align: left;
  color: ${(props) =>
    props.$isWarning && props.$isDrayNow
      ? '#262626'
      : props.$isWarning && !props.$isDrayNow
        ? '#2B4141'
        : props.$isDrayNow
          ? '#b15c60'
          : '#E63734'};
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const ReturnLoginButton = styled(LoginButton)`
  margin: 24px 0 48px 0 !important;
  width: 100% !important;
`
